import Action from "../actions";

export function userManagementReducer(state = {
    viewList: {
        userList: [],
        total: 0
    },
    addNew: {
        isValid: false,
        isChecked: true
    },
    userProfile: {},
    changePassword: {
        isShowNew: false,
        isShowConfirm: false,
        isNotOkNew: false,
        isNotOkConfirm: false,
        isMatch: true,
        newPwd: '',
        confirmPwd: '',
        isValid: false

    }

}, action) {
    if (action.type === Action.SET_USER_MANAGEMENT) {
        return action.data
    }
    return state;
}
